import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  idEmpresa: string;
  idUsuario: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idEmpresa = infoUsu.empresaId;
  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  getProdCertAct(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  getStatusTemplate(productoId: string){
    let datos: any = {productoId,	template: 1};
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusTemplate(datos){
    console.log("datos control",datos);
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  DesbloquearPasoTemplate(datos){
    console.log("datos control",datos);
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  getPreguntasCatalogo(instituto:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.getCatalogo + instituto + "/0");
  }

  getIdiomasProd(fecha: any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getIdiomasGuardados + this.idEmpresa, fecha);
  }

  getSeccionesCuestionario(surveyProductId:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.getSeccionesCuestionario + surveyProductId);
  }

  getCatDatosForAll(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.catalogos.datosForAll + localStorage.getItem('instituto_id'));
  }

  getCatDemograficos(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.catalogos.demograficos);
  }
  getCatIdiomasSurvey(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.catalogos.idiomas);
  }

  setPreguntaCatMaster(datosPregunta:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.setPreguntaCatMaster, datosPregunta);
  }

  getCatRespuestasReactivos(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.catalogos.respuestasReactivos);
  }

  setSeccionesCuestionario(surveyProductId:any, secciones:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.seccionesCatMaster.setSeccionesCuestionario + surveyProductId, secciones);
  }

  postActualizaTemplate(datos){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.certificar3.seccionTemplate.postActualizaTemplate,datos);
  }

  getActualizaTemplate(surveyProductId:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.certificar3.seccionTemplate.getActualizaTemplate + surveyProductId);
  }


}
